<template>
        <!-- v-click-outside="doClickOutside" -->
    <tr
      @keydown.esc="cancel"
      @click="startEditMode"
      :class="{'problematicArticle': problematicArticle}"
    >
        <td>{{article_name}}</td>
        <td>{{category_name}}</td>
        <td>{{purchase_measurement_unit_name}}</td>
        <td>
            <v-text-field
                style="margin: 0!important; padding: 0!important;"
                v-model="new_quantity"
                ref="new_quantity"
                @keydown="preventLetters"
                @keydown.enter="parseQuantityInput(); save();"
                @keydown.tab.prevent="parseQuantityInput(); save();"
                @focus="$emit('setCurrent', article.sort); startEditMode(); $event.target.select()"
                @blur.prevent="new_quantity && parseQuantityInput(); handleBlur('new_quantity');"
                :disabled="saving"
            ></v-text-field>
        </td>
        <td>{{quantity}}</td>
        <td>{{difference | price(2)}}</td>
        <td>
          <!-- @blur.prevent="average_purchase_price && parsePriceInput(); stopEditMOde(); handleBlur('average_purchase_price');" -->
          <v-text-field
                style="margin: 0!important; padding: 0!important;"
                v-model="average_purchase_price"
                ref="pnc"
                @keydown="preventLetters"
                @keydown.enter="parsePriceInput(); save();"
                @keydown.tab.prevent="parsePriceInput(); save();"
                @focus="$emit('setCurrent', article.sort); startEditMode();"
                @blur.prevent="average_purchase_price && parsePriceInput(); handleBlur('average_purchase_price');"
                :disabled="saving"
            ></v-text-field>
        </td>

        <td class='text-right' v-show="!saving && editMode">
            <ButtonActionSave @click.stop="save" />
            <ButtonActionCloseEditing @click.stop="cancel" />
        </td>
        <td v-show="saving">
            <v-progress-circular
              :size="20"
              indeterminate
              color="teal"
            ></v-progress-circular>
        </td>
    </tr>
</template>

<script>
import ButtonActionSave from '@/components/ButtonActionSave'
import ButtonActionCloseEditing from '@/components/ButtonActionCloseEditing'
// import ButtonActionDelete from '@/components/ButtonActionDelete'
import { parseSiFloat } from '@/utils/number'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  components: {
    ButtonActionSave,
    ButtonActionCloseEditing,
    // ButtonActionDelete
  },
  props: {
    article: {
      default: () => {},
      type: Object
    },
    isNewArticle: {
      required: false,
      type: Boolean
    }, newKez: {
      type: Number,
    }/* ,
    articles: {
      required: true,
      type: Array
    } */
  },
  data () {
    return {
      article_name: null,
      category_name: null,
      new_quantity: null,
      quantity: null,
      price: null,
      purchase_measurement_unit_name: 0,
      latest_purchase_price: 0,
      average_purchase_price: 0,
      latest_sell_price: 0,
      latest_netto_sell_price: 0,
      amount_latest_purchase_price: 0,
      amount_average_purchase_price: 0,
      amount_latest_sell_price: 0,
      amount_latest_netto_sell_price: 0,
      editMode: false,
      problematicArticle: false,
      saving: false
    }
  },
  computed: {
    difference () {
      if (this.new_quantity && this.new_quantity.length &&this.new_quantity.includes(',')) {
        return this.new_quantity.split(',').join('.') - this.quantity
      } else {
        return this.new_quantity - this.quantity
      }
    }
  },
  methods: {
    ...mapActions('articleStock', ['loadItem']),
    setCurrentRowData (article) {
      this.new_quantity = this.isNewArticle ? null : (!article.addedAfter ? article.quantity < 0 ? 0 : article.new_quantity : null) // vrjetno napaka
      this.article_name = article.article_name
      this.category_name = article.category_name
      this.quantity = article.quantity || article.quantity_calculated || 0
      this.purchase_measurement_unit_name = article.purchase_measurement_unit_name ? article.purchase_measurement_unit_name : '?'
      this.latest_sell_price = article.latest_sell_price || article.price
      this.average_purchase_price = article.average_purchase_price || 0
      this.price = article.price || 0
      this.problematicArticle = article.problematicArticle
      // console.log(this.new_quantity)
      if (this.new_quantity) {
        this.parseQuantityInput()
      }
      /* if (article.article === 1352775795) {
        console.log(article)
      } */
      /* this.latest_purchase_price = article ? article.latest_purchase_price : null
      this.latest_netto_sell_price = article ? article.latest_netto_sell_price : null
      this.amount_latest_purchase_price = article ? article.amount_latest_purchase_price : null
      this.amount_average_purchase_price = article ? article.amount_average_purchase_price : null
      this.category_name = article ? article.category_name : null
      this.amount_latest_sell_price = article ? article.amount_latest_sell_price : null
      this.amount_latest_netto_sell_price = article ? article.amount_latest_netto_sell_price : null */
      this.saving = this.saving || false
    },
    handleBlur (type) {
      // console.log('handled inventory blue: ', this.new_quantity, this.average_purchase_price, type)
      if (!this.new_quantity && !this.average_purchase_price) {
        return
      } else {
        if (this.selectedArticle) {
          this.parseAllInputs()
          const saveItem = {
            article: this.selectedArticle.article,
            quantity: this.new_quantity,
            price: this.average_purchase_price || this.latest_sell_price // this.price ? this.latest_sell_price : this.article.price
          }
          this.$emit('updateBlur', saveItem)
        }
      }
    },
    async save (tip) {
      if (!this.new_quantity && !this.average_purchase_price)
      {
        this.$emit('gotonext')
        return
      }
      if (this.selectedArticle) {
        this.saving = true
        this.parseAllInputs()
        const saveItem = {
          article: this.selectedArticle.article,
          quantity: this.new_quantity,
          price: this.average_purchase_price || this.latest_sell_price // this.price ? this.latest_sell_price : this.article.price
        }

        const event = /* this.isNewArticle ? 'save' :  */'update'
        this.$emit(event, saveItem)
        // console.log(saveItem, this.selectedArticle)
        this.editMode = false
        this.saving = false
      }
    },
    parseAllInputs () {
      this.parseQuantityInput()
    },
    parseQuantityInput () {
      // if (!this.new_quantity) this.new_quantity = this.quantity
      if (!this.new_quantity) return
      this.new_quantity = parseSiFloat(this.new_quantity, 2)
    },
    parsePriceInput () {
      // if (!this.average_purchase_price || this.average_purchase_price < 0) this.average_purchase_price = 0
      this.average_purchase_price = parseSiFloat(this.average_purchase_price, 2)
    },
    preventLetters ($event) {
      var keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if (keyCode > 64 && keyCode < 91) {
        $event.preventDefault()
      }
    },
    async doClickOutside () {
      if (this.editMode) {
        await this.save()
        this.editMode = false
      }
    },
    startEditMode () {
      if (!this.editMode) {
        this.editMode = true
        this.$nextTick(() => {
          this.$refs.new_quantity.focus()
        })
      }
    },
    stopEditMOde () {
      if (this.editMode) {
        this.editMode = false
      }
    },
    setStartingArticleFields (article = null) {
      const data = article || this.article
      this.setCurrentRowData(data)
      this.selectedArticle = data
      // console.log(data)
      // this.selectedArticle = this.articles.find(article => article.id === data.article)
    },
    cancel (event) {
      if (this.isNewArticle) {
        this.$emit('cancel')
      } else {
        this.editMode = false
        this.setCurrentRowData(this.article)
        // this.selectedArticle = data // this.articles.find(article => article.id === this.article.article)
      }
    }
  },
  mounted () {
    // if (this.isNewArticle) {
    this.setStartingArticleFields()
    // this.startEditMode()
    /* } else {
      this.startEditMode()
    } */
  },
  watch: {
    article (val) {
      this.setStartingArticleFields()
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .v-text-field__details {
    display: none !important;
  }

  .problematicArticle {
    background: #be8c8c;
    &:hover {
      background: #be8c8c !important;
    }
  }
</style>
